// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidationSlider_container__3unsC","hideDottedSkull":"ValidationSlider_hideDottedSkull__3JvaT"};